const threshold = 200;
const floatingClass = 'gbsc--floatingShopNow';

function init() {
  let isFloating = (window.scrollY > threshold);
  document.body.classList.toggle(floatingClass, isFloating);

  window.addEventListener('scroll', () => {
    let newFloating = (window.scrollY > threshold);
    
    if (newFloating !== isFloating) {
      isFloating = newFloating;
      document.body.classList.toggle(floatingClass, newFloating);
    }
  });
}

export default { init };